import {useState, useRef} from "react";
import CustomInput from "./CustomInput";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

const HireMeForm = ({closeModal, setToast}) => {
  const recaptchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [error, setError] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === "email") {
      e.target.setCustomValidity(validateEmail(value) ? "" : "Please enter a valid email address");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!formData.name || !formData.email || !formData.message) {
      setError({
        name: !formData.name ? "Name is required" : "",
        email: !formData.email ? "Email is required" : "",
        message: !formData.message ? "Message is required" : "",
      });
      return;
    }

    if (!validateEmail(formData.email)) {
      setError({email: "Please enter a valid email address"});
      return;
    }

    if (!captchaToken) {
      setToast({
        show: true,
        message: "Please complete the captcha",
        type: "error",
      });
      return;
    }

    try {
      setError({name: "", email: "", message: ""});
      setIsLoading(true);

      const res = await axios.post("https://email-sender-steel.vercel.app/api/send-mail", {
        ...formData,
        captcha: captchaToken, // optionally send it to backend to verify
      });

      if (res.status === 200) {
        setFormData({name: "", email: "", message: ""});
        recaptchaRef.current.reset(); // reset captcha
        setCaptchaToken(null);
        closeModal();
        setToast({
          show: true,
          message: res.data.message,
          type: "success",
        });
      }
    } catch (error) {
      console.error(error);
      setToast({
        show: true,
        message: "Failed to send the message. Please try again later.",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2 className="text-3xl font-bold mb-4">Contact Me</h2>
      <p className="mb-4">Thank you for your interest! Please fill out the form below to get in touch.</p>

      <div className="md:flex gap-5 w-full">
        <CustomInput className="w-full" onChange={handleInputChange} value={formData.name} label="Name" name="name" placeholder="Your Name" error={error.name} errorMessage={error.name} />
        <CustomInput className="w-full" onChange={handleInputChange} value={formData.email} label="Email" name="email" placeholder="Your Email" error={error.email} errorMessage={error.email} />
      </div>

      <CustomInput onChange={handleInputChange} value={formData.message} label="Message" name="message" placeholder="Enter the message" isTextArea={true} error={error.message} errorMessage={error.message} />

      {/* reCAPTCHA */}
      <div className="my-4">
        <ReCAPTCHA sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA} ref={recaptchaRef} onChange={(token) => setCaptchaToken(token)} />
      </div>

      <button className="bg-x-yellow text-2xl rounded-full text-x-gray-dark font-bold h-14 w-48 p-3 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center" style={{boxShadow: "5px 5px 0px 5px black"}} type="submit" disabled={isLoading}>
        {isLoading ? (
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 border-2 border-x-gray-dark border-t-transparent rounded-full animate-spin"></div>
            <span>Sending...</span>
          </div>
        ) : (
          "Send"
        )}
      </button>
    </form>
  );
};

export default HireMeForm;
